import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse } from '../models/api-response.model';
import { Item } from '../models/item.model';

@Injectable({
  providedIn: 'root'
})
export class ItemService {
  constructor(private httpClient: HttpClient) {}

  protected static getCreateUri(): string {
    return environment.apiUrl + 'finance/items';
  }

  protected static getIndexUri(): string {
    return environment.apiUrl + 'finance/items';
  }

  protected static getRequestUri(itemId: string): string {
    return environment.apiUrl + 'finance/items/' + itemId;
  }

  private static getOptions(params?: object): object {
    return {
      params: params,
      withCredentials: true,
      headers: {
        Accept: 'application/json'
      }
    };
  }

  createItem(item: Item, params: object): Observable<ApiResponse<Item>> {
    return this.httpClient.post<ApiResponse<Item>>(ItemService.getCreateUri(), item, ItemService.getOptions(params));
  }

  editItem(item: Item, params: object): Observable<ApiResponse<Item>> {
    return this.httpClient.put<ApiResponse<Item>>(ItemService.getRequestUri(item.id), item, ItemService.getOptions(params));
  }
}
